<template>
  <div
    v-if="items"

    class="list"

    :style="{ '--lcolorFrom': bgColor, '--lcolorTo': $options.utils.hexToRGBA( bgColor, 0 ) }"
  >
    <div
      v-if="title"
      class="title"
    >{{ title }}</div>

    <div class="scrollWrapper">
      <div class="scroller">
        <div
          v-for="( i, id ) in items_"
          :key="i.id ? i.id : id"
        >
          <Checkbox
            :label="i.name"
            v-model="i.checked"

            :class="isAgg ? 'disabled' : ''"

            @input="chkSet()"
          />

          <Checkbox
            v-if="agg && ( 'agg' in i )"

            :class="isChk ? 'disabled' : ''"
            style="margin-left: 1em; font-weight: bold;"

            label="∑"
            v-model="i.agg"

            @input="aggSet()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Checkbox from "../components/Checkbox";
import utils from "@/utils"


export default {
  name: "list",

  components: {
    Checkbox
  },

  props: {
    title: {
      type: String,
      default: null
    },

    items: {
      type: Array|Object,
      default: () => null
    },

    bgColor: {
      type: String,
      default: "#DBF1FF"
    },

    agg: {
      type: Boolean,
      default: false
    }
  },

  i18n: {
    messages: {
      ru: {
        sum: "суммировать"
      },

      en: {
        sum: "summarize"
      },

      kz: {
        sum: "қорытындылау"
      }
    }
  },

  utils,

  data() {
    return {
      items_: null
    }
  },

  methods: {
    chkSet() {
      if ( this.agg ) {
        for ( const id in this.items_ ) {
          if ( this.items_.hasOwnProperty( id ) && this.items_[ id ].agg ) this.$set( this.items_[ id ], "agg", false );
        }
      }

      this.$emit( 'input', this.items_ );
    },
    aggSet() {
      if ( this.agg ) {
        for ( const id in this.items_ ) {
          if ( this.items_.hasOwnProperty( id ) && this.items_[ id ].checked ) this.$set( this.items_[ id ], "checked", false );
        }
      }

      this.$emit( 'input', this.items_ );
    }
  },

  computed: {
    isAgg() {
      if ( this.agg ) {
        for ( const id in this.items_ ) {
          if ( this.items_.hasOwnProperty( id ) && this.items_[ id ].agg ) return true;
        }
      }

      return false;
    },

    isChk() {
      if ( this.agg ) {
        for ( const id in this.items_ ) {
          if ( this.items_.hasOwnProperty( id ) && this.items_[ id ].checked ) return true;
        }
      }

      return false;
    }
  },

  watch: {
    items: {
      immediate: true,
      handler() {
        this.items_ = JSON.parse( JSON.stringify( this.items ) );
      }
    }
  }
}
</script>

<style scoped>
.list {
  position: relative;
}

.list > .title {
  color: #0081CA;
  margin: 0 0 0.5em 0;
  position: relative;
  font-weight: bold;
}

.list > .scrollWrapper {
  display: table;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.list > .scrollWrapper > .scroller {
  display: block;
  max-height: 15em;
  overflow: auto;
  padding: 1em 0;
}
.list > .scrollWrapper > .scroller > * {
  display: block;
  margin: 0 0 0.5em 0;
}
.list > .scrollWrapper > .scroller > *::v-deep,
.list > .scrollWrapper > .scroller > *::v-deep > label::before {
  transition: all 0.12s linear;
}
.list > .scrollWrapper > .scroller > *::v-deep:hover {
  color: #0081CA;
}
.list > .scrollWrapper > .scroller > *::v-deep:hover > label::before {
  border-color: #0081CA;
}

.list > .scrollWrapper::before,
.list > .scrollWrapper::after {
  content: "";
  position: absolute;
  height: 1em;
  left: 0;
  right: 0;
  z-index: 100;
  pointer-events: none;
}
.list > .scrollWrapper::before {
  top: 0;
  background: linear-gradient( #DBF1FF, rgba( 219, 241, 255, 0.5 ) );
}
.list > .scrollWrapper::after {
  bottom: 0;
  background: linear-gradient( rgba( 219, 241, 255, 0.5 ), #DBF1FF );
}

.disabled {
  pointer-events: none;
}
.disabled::v-deep label:before,
.disabled::v-deep label:after {
  opacity: 0.3;
}
</style>
